import React from "react";
// import { useContext } from "react";

import Header from "./Header/Header";
import Footer from "./Footer/Footer";
// import { EventComponent } from "@components/EventComponent";

import Styles from "./Layout.module.scss";
import classNames from "classnames";
import { useLayout } from "@/cms/components/LayoutContextAPI/useLayout";
import { useLocation } from "react-router-dom";

const Breadcrumbs = React.lazy(() => import("./BreadcrumbMenu/Breadcrumbs"));
// import AppContext from "../context/AppContext";

const pagesWithoutBreadcrumb = ["/wechselservice", "/angebote", "/tarifoptimierung", "/freunde-werben-freunde"];
const exceptions = ["/internal/wechselservice-vollmacht"];
const hideBreadcrumb = (path: string) => {
  if (exceptions.some((exception) => path.includes(exception))) {
    return false;
  }

  return pagesWithoutBreadcrumb.some((pagePath) => path.includes(pagePath));
};

export const Layout = ({ children }: { children: React.ReactNode }) => {
  const { state } = useLayout();
  const location = useLocation();
  // const { impersonatorToken } = useContext(AppContext);
  const impersonatorToken = localStorage.getItem("impersonator_token");
  return (
    <div id="mainLayout" className={classNames(Styles.mainLayout, Styles.minHeightBody, "flavour-remindme")}>
      <div className={Styles.mainHeader}>
        <Header />
      </div>
      <div className={classNames(Styles.mainBody, impersonatorToken && Styles.topMargin)}>
        {/* <EventComponent /> */}
        <div className={Styles.contentContainer}>
          <div className={classNames(Styles.contentWrapper, Styles[state.pageType || "fullScreen"])}>
            {state?.breadcrumbs && !hideBreadcrumb(location.pathname) && (
              <div className={classNames(Styles.breadcrumbsWrapper, Styles[state.breadcrumbsLayout || ""])}>
                <Breadcrumbs location={location} />
              </div>
            )}
            {children}
          </div>
        </div>
      </div>
      <div className={Styles.mainFooter}>
        <Footer />
      </div>
    </div>
  );
};
